import React from "react";
import Status from "../Status";
import S from "./Window.styled";
const Window = ({ children }) => (React.createElement(S.Wrapper, null,
    React.createElement(S.Container, null, children),
    React.createElement(Status, null)));
export default Window;
//# sourceMappingURL=Window.js.map